import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { ModalContext } from '../context/modalContext';
import Card from './Card'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
        margin-top: 60px;
        margin-bottom: 12px;
    }
    p {
        font-weight: 500;
    }
    .cards {
        justify-content: center;
        display: grid;
        width: 100%;
        grid-template-columns: repeat(auto-fill, 220px);
        gap: 45px;
        margin-top: 60px;
    }
`

function Services() {

    const { modal1, setModal1, modal2, setModal2, modal3, setModal3, modal4, setModal4 } = useContext(ModalContext)

    useEffect(() => {
        if (modal1 || modal2 || modal3 === true) {
            document.body.classList.add('overflow');
        } else {
            document.body.classList.remove('overflow');
        }
    }, [modal1, modal2, modal3])

    return (
        <Wrapper>
            <h2 id='services'>Serviços</h2>
            <p>O que eu faço?</p>
            <div className='cards'>
                <Card modal={modal1} setModal={setModal1} />
                <Card modal={modal2} setModal={setModal2} />
                <Card modal={modal3} setModal={setModal3} />
                <Card modal={modal4} setModal={setModal4} />
            </div>
        </Wrapper>
    );
}

export default Services;